<template>
  <v-stepper
    v-model="currentStep"
    class="elevation-0"
  >
    <v-stepper-header
      class="d-flex justify-end align-center"
    >
      <div
        v-if="!isEdit"
        class="d-flex justify-end"
        style="overflow: hidden"
      >
        <div
          v-for="(step, index) in steps"
          
          :key="index + 1"
          class="stepper__wrapper"
        >
          <v-divider v-if="index === 0" />
          <v-stepper-step
            :complete="currentStep > index + 1 || complete"
            :editable="currentStep > index + 1"
            :step="index + 1"
            edit-icon="$complete"
          >
            {{ step }}
          </v-stepper-step>
          <v-divider />
        </div>
      </div>
    </v-stepper-header>
    <v-stepper-items ref="stepperItems">
      <slot>
        <!--
          Add your own v-stepper-content elements here.
          Make a ref to this component in the parent component and
          call next or previous on the ref to change the steps, based
          on your step logic.
        -->
      </slot>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Stepper',
  props: {
    steps: {
      type: Array,
      default: () => [],
      description: 'An array of strings: the step titles'
    },
    isEdit: {
      type: [Boolean],
      default: false
    },
    startStep: {
      type: [Number],
      default: 1
    }
  },
  data() {
    return {
      currentStep: this.startStep
    }
  },
  computed: {
    ...mapState('order/submitButton', ['complete'])
  },
  watch: {
    currentStep: function (val) {
      this.$emit('change', val)
    }
  },
  methods: {
    previous() {
      if (this.currentStep > 1) {
        this.currentStep -= 1
      }
    },
    next() {
      if (this.currentStep < this.steps.length) {
        this.currentStep += 1
      }
    },
    scrollToTop() {
      this.$vuetify.goTo(this.$refs.stepperItems)
    },
    restart() {
      this.currentStep = 1
    },
    setStep(step) {
      this.currentStep = step
    }
  }
}
</script>

<style lang="scss" scoped>
.stepper {
  &__wrapper {
    display: flex;
    align-items: center;
    width: 100px;
  }
}
</style>
<style lang="scss">
.v-stepper {
  &__header {
    justify-content: flex-start;
  }

  &__step {
    position: relative;
    padding: 28px;
  }

  &__label {
    display: block;
    position: absolute;
    top: calc(100% - 20px);
    font-size: 0.8rem;
    left: 0;
    right: 0;
    margin: 0 auto;
    text-align: center !important;
  }
}
</style>
